import * as UI from "@iyk/ui"
import * as React from "react"

const Container = ({ children }: Container.Props) => {
  return (
    <div className="relative hover:cursor-pointer aspect-video w-full rounded overflow-hidden">
      {children}
    </div>
  )
}

const CoverImage = ({ src, alt }: CoverImage.Props) => (
  <div className="absolute inset-0 size-full">
    <img src={src} alt={alt} className="size-full object-cover" />
    <div className="absolute bottom-0 left-0 w-full h-1/4 bg-[linear-gradient(to_top,_black,_rgba(0,0,0,0))]" />
  </div>
)

const Heading = ({ children }: Heading.Props) => (
  <div className="absolute left-2 bottom-2 text-xs text-start flex flex-col gap-0.5">{children}</div>
)

const Title = ({ children }: Title.Props) => (
  <h3 className="[text-shadow:1px_1px_5px_rgba(0,0,0,0.3)]">{children}</h3>
)

const Subtitle = ({ children }: Subtitle.Props) => (
  <p className="text-gray-11 [text-shadow:1px_1px_3px_rgba(0,0,0,1)]">{children}</p>
)

const IconButton = ({ children }: IconButton.Props) => (
  <div className="absolute right-2 bottom-2">
    <span className={UI.classForButton({ kind: "solid", size: "sm" })}>{children}</span>
  </div>
)

namespace Container {
  export type Props = {
    children: React.ReactNode
  }
}

namespace CoverImage {
  export type Props = {
    src: string
    alt: string
  }
}

namespace Heading {
  export type Props = {
    children: React.ReactNode
  }
}

namespace Title {
  export type Props = {
    children: React.ReactNode
  }
}

namespace Subtitle {
  export type Props = {
    children: React.ReactNode
  }
}

namespace IconButton {
  export type Props = {
    children: React.ReactNode
  }
}

export const ExclusiveCard = {
  Container,
  CoverImage,
  Heading,
  Title,
  Subtitle,
  IconButton
}
